__turbopack_context__.v({
  "actionButton": "ClubProfileCard-module-scss-module__3LlqnW__actionButton",
  "actionButtons": "ClubProfileCard-module-scss-module__3LlqnW__actionButtons",
  "actionSlot": "ClubProfileCard-module-scss-module__3LlqnW__actionSlot",
  "avatar": "ClubProfileCard-module-scss-module__3LlqnW__avatar",
  "avatarSection": "ClubProfileCard-module-scss-module__3LlqnW__avatarSection",
  "avatarSkeleton": "ClubProfileCard-module-scss-module__3LlqnW__avatarSkeleton",
  "avatarWrapper": "ClubProfileCard-module-scss-module__3LlqnW__avatarWrapper",
  "badgeSkeleton": "ClubProfileCard-module-scss-module__3LlqnW__badgeSkeleton",
  "bio": "ClubProfileCard-module-scss-module__3LlqnW__bio",
  "bioSkeleton": "ClubProfileCard-module-scss-module__3LlqnW__bioSkeleton",
  "bioSkeletonShort": "ClubProfileCard-module-scss-module__3LlqnW__bioSkeletonShort",
  "bottomInfo": "ClubProfileCard-module-scss-module__3LlqnW__bottomInfo",
  "card": "ClubProfileCard-module-scss-module__3LlqnW__card",
  "cardInner": "ClubProfileCard-module-scss-module__3LlqnW__cardInner",
  "copyIcon": "ClubProfileCard-module-scss-module__3LlqnW__copyIcon",
  "country": "ClubProfileCard-module-scss-module__3LlqnW__country",
  "deletedAccountNotice": "ClubProfileCard-module-scss-module__3LlqnW__deletedAccountNotice",
  "editButtonSkeleton": "ClubProfileCard-module-scss-module__3LlqnW__editButtonSkeleton",
  "editRow": "ClubProfileCard-module-scss-module__3LlqnW__editRow",
  "flag": "ClubProfileCard-module-scss-module__3LlqnW__flag",
  "flagImage": "ClubProfileCard-module-scss-module__3LlqnW__flagImage",
  "infoSection": "ClubProfileCard-module-scss-module__3LlqnW__infoSection",
  "location": "ClubProfileCard-module-scss-module__3LlqnW__location",
  "locationSkeleton": "ClubProfileCard-module-scss-module__3LlqnW__locationSkeleton",
  "mainContent": "ClubProfileCard-module-scss-module__3LlqnW__mainContent",
  "moderationIcon": "ClubProfileCard-module-scss-module__3LlqnW__moderationIcon",
  "moderationPill": "ClubProfileCard-module-scss-module__3LlqnW__moderationPill",
  "moderationText": "ClubProfileCard-module-scss-module__3LlqnW__moderationText",
  "name": "ClubProfileCard-module-scss-module__3LlqnW__name",
  "nameHeaderRow": "ClubProfileCard-module-scss-module__3LlqnW__nameHeaderRow",
  "nameRow": "ClubProfileCard-module-scss-module__3LlqnW__nameRow",
  "nameSkeleton": "ClubProfileCard-module-scss-module__3LlqnW__nameSkeleton",
  "profileCheckMark": "ClubProfileCard-module-scss-module__3LlqnW__profileCheckMark",
  "profileSocialIcon": "ClubProfileCard-module-scss-module__3LlqnW__profileSocialIcon",
  "profileSocialIcons": "ClubProfileCard-module-scss-module__3LlqnW__profileSocialIcons",
  "shimmer": "ClubProfileCard-module-scss-module__3LlqnW__shimmer",
  "skeleton": "ClubProfileCard-module-scss-module__3LlqnW__skeleton",
  "socialSkeleton": "ClubProfileCard-module-scss-module__3LlqnW__socialSkeleton",
  "sportIcon": "ClubProfileCard-module-scss-module__3LlqnW__sportIcon",
  "sportRow": "ClubProfileCard-module-scss-module__3LlqnW__sportRow",
  "sportText": "ClubProfileCard-module-scss-module__3LlqnW__sportText",
  "topInfo": "ClubProfileCard-module-scss-module__3LlqnW__topInfo",
  "verifiedBadge": "ClubProfileCard-module-scss-module__3LlqnW__verifiedBadge",
});
